import TileLayer from 'ol/layer/WebGLTile';
import XYZSource from 'ol/source/XYZ';

export const mapHost = "https://map.chb2.com";
export let mapSource = "google";

export default class GoogleMap extends TileLayer {
    static get layerName() {
        return 'google-map';
    }

    constructor(opt_options) {
        let google = ((opt_options || {}).mapSource || mapSource) === "google";
        super(Object.assign({
            name: GoogleMap.layerName,
            source: new XYZSource({
                crossOrigin: 'anonymous',
                url: google ? `${mapHost}/map/{z}/{x}/{y}`
                    : "https://wprd01.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=7&ltype=1",
            })
        }, opt_options));
    }
}
